export const MERGE_LIST_ITEMS = [
  'DocumentType',
  'Entity',
  'ExternalDataSource',
  'SynchronizationConfig',
];

export const MERGE_OVERWRITE_LIST_ITEMS = [
  'ApplicationMigrationConfig',
  'ApplicationSetting',
  'EntityCatalog',
  'Menu',
  'SolutionFramework',
];

export const OVERWRITE_LIST_ITEMS = [
  'CrystalReport',
  'Culture',
  'Dashboard',
  'EntityColumn',
  'EntitiesUploadConfig',
  'Form',
  'FormatTypes',
  'FormsConfiguration',
  'R2T',
  'Report',
  'ReportModel',
  'Right',
  'Search',
  'SubmissionForm',
  'Translation',
  'Workflow',
];

export const SKIP_OVERWRITE_LIST_ITEMS = [
  'ApplicableStandard',
  'ApplicationOption',
  'Assessment',
  'Auditee',
  'AuditNoteType',
  'AuditResponseType',
  'AuditResultType',
  'AuditReviewModel',
  'AuditReviewType',
  'AuditStatus',
  'AuditType',
  'Cause',
  'CauseCategory',
  'CertificationStatus',
  'ChangeOrderCategory',
  'ChangeOrderPolicy',
  'ChangeOrderStatus',
  'Checklist',
  'Client',
  'ContainmentTaskType',
  'CorrectionTaskType',
  'CostElement',
  'CourseStatus',
  'CourseType',
  'CriteriaReviewType',
  'CriteriaStatus',
  'CriteriaType',
  'Department',
  'DispositionTaskType',
  'DispositionType',
  'DocumentAttribute',
  'DocumentCategory',
  'DocumentMemberType',
  'DocumentRepositoryConfiguration',
  'DocumentReviewModel',
  'DocumentReviewType',
  'DocumentStatus',
  'EntityData',
  'Escalation',
  'ExceptionType',
  'FailureModeCategory',
  'GenericTaskType',
  'Group',
  'ImplementationTaskType',
  'InternalActor',
  'InvestigationTaskType',
  'IssueStatus',
  'IssueTaskModel',
  'Machine',
  'NumberingScheme',
  'Operation',
  'Organization',
  'OrganizationUnit',
  'Part',
  'Person',
  'PersonStatus',
  'Phase',
  'PlantArea',
  'Position',
  'Priority',
  'ProcessFailureMode',
  'ProcessSuspectFailureMode',
  'ProductCorrectionTask',
  'ProductFailureMode',
  'ProductFamily',
  'ProductLine',
  'ResponseSet',
  'ResponseTaskType',
  'ReviewEscalation',
  'RightsGroup',
  'Role',
  'RoleRequirement',
  'Severity',
  'Site',
  'StandardLibrary',
  'StandardOperation',
  'TrainingResult',
  'TrainingStatus',
  'TrainingType',
  'Unit',
  'WorkCenter',
  'SS_QI_REPORT_SETUP',
];

export const DELETE_IMPORT_SKIP_OVERWRITE_LIST_ITEMS = ['List', 'Group'];

export const ID_HEADER = 'id';
export const ID_ACCESSOR = 'id';
export const CHECKED_HEADER = 'Checked';
export const CHECKED_ACCESSOR = 'Checked';
export const ACTION_FOR_DUPLICATE_ITEM_HEADER = 'Action for Duplicate Item';
export const ACTION_FOR_DUPLICATE_ITEM_ACCESSOR = 'DuplicateRowModelAction';
export const BUILD_FILE_DUPLICATE_ROW_MODEL_ACTION_ACCESSOR = 'BuildFileDuplicateRowModelAction';
export const APPLICATION_COMPONENT_NAME_HEADER = 'Application Component Name';
export const APPLICATION_COMPONENT_NAME_ACCESSOR = 'Name';
export const TYPE_HEADER = 'Type';
export const TYPE_ACCESSOR = 'Type';
export const ORGANIZATION_CODE_HEADER = 'Organization Code';
export const ORGANIZATION_CODE_ACCESSOR = 'OrganizationCode';
export const LAST_MODIFIED_DATE_HEADER = 'Last Modified Date (GMT)';
export const LAST_MODIFIED_DATE_ACCESSOR = 'LastModifiedDate';
export const LAST_MODIFIED_BY_HEADER = 'Last Modified By';
export const LAST_MODIFIED_BY_ACCESSOR = 'LastModifiedBy';
export const STATUS_HEADER = 'Status';
export const STATUS_ACCESSOR = 'StatusCode';
export const MESSAGE_HEADER = 'Message';
export const MESSAGE_ACCESSOR = 'Messages';
export const ACTION_ACCESSOR = 'Action';
export const COMPARISON_MESSAGE_ACCESSOR = 'ComparisonMessage';
export const COMPARISON_DESIGNER_LINK = 'ComparisonDesignerLink';
export const COMPARISON_DELTA_LINK = 'ComparisonDeltaLink';
export const STATUS_EXPORT_HEADER = 'Status';
export const STATUS_EXPORT_ACCESSOR = 'Status';
export const COMMENT_ACCESSOR = 'Comment';
export const COMMENT_HEADER = 'Change Comment';
export const COMMENT_HEADER_IMPORT = 'Comment';
